export default __webpack_public_path__ + "static/media/sale.5095d2f3.svg";